"use client";

import { dispatchRouteChangeEvent } from '@/utils/routeEvents';
import { usePathname } from 'next/navigation';
import { useEffect } from "react";

export default function Template({ children }: { children: React.ReactNode }) {
    const pathname = usePathname()
    useEffect(() => {
        dispatchRouteChangeEvent("completed");
    }, [pathname]);
    return <div>{children}</div>;
}